import { Vue, Component } from 'vue-property-decorator'
import FormSearchDocument from '../../components/home/FormSearchDocument.component.vue'
import Axios from 'axios'

@Component(
  {
    components: {
      FormSearchDocument
    }
  }
)
export default class HomePageComponent extends Vue {
  found: boolean = false
  snackbarError: boolean = false
  data: Object = {}

  onSearchDocument (data: Object) {
    this.data = data
    this.found = true
  }

  onError () {
    this.snackbarError = true
  }

  onDownloadPDF () {
    const a = document.createElement('a')
    const path = Object.entries(this.data).map((e) => e.join('=')).join('&')
    a.href = `${Axios.defaults.baseURL}/documents/print-pdf?${path}`
    a.click()
  }

  onDownloadXML () {
    const a = document.createElement('a')
    const path = Object.entries(this.data).map((e) => e.join('=')).join('&')
    a.href = `${Axios.defaults.baseURL}/documents/xml?${path}`
    a.click()
  }

  onReset () {
    this.found = false
    this.data = {}
  }
}
